"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fragment = exports.default = exports.HitMeta = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _UnitTile = _interopRequireWildcard(require("@oberoninternal/travelbase-ds/components/misc/UnitTile"));
var _Title = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Title"));
var _useRandom = require("@oberoninternal/travelbase-ds/hooks/useRandom");
var _Package = _interopRequireDefault(require("@oberoninternal/travelbase-ds/svg/Package.svg"));
var _Special = _interopRequireDefault(require("@oberoninternal/travelbase-ds/svg/Special.svg"));
var _grid = require("@rebass/grid");
var _client = require("@apollo/client");
var _link = _interopRequireDefault(require("next/link"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TenantContext = require("../context/TenantContext");
var _graphql = require("../generated/graphql");
var _createPlaceholder = _interopRequireDefault(require("../utils/createPlaceholder"));
var _createUnitTitle = _interopRequireDefault(require("../utils/createUnitTitle"));
var _getRentalUnitSummaryText = _interopRequireDefault(require("../utils/getRentalUnitSummaryText"));
var _trip = require("../utils/trip");
var _LinkWrapper = _interopRequireDefault(require("./LinkWrapper"));
var _Rating = _interopRequireDefault(require("./Rating"));
var _Stack = _interopRequireDefault(require("./Stack"));
var _theme = require("@oberoninternal/travelbase-ds/constants/theme");
var _EmptyStar = _interopRequireDefault(require("./svg/EmptyStar.svg"));
var _getPercentage = _interopRequireDefault(require("../utils/getPercentage"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _queryString = require("query-string");
var _FavoriteIconButton = _interopRequireDefault(require("./FavoriteIconButton"));
var _useGetPageSlugByLocale = _interopRequireDefault(require("../hooks/useGetPageSlugByLocale"));
const _excluded = ["arrivalDate", "departureDate"],
  _excluded2 = ["rentalUnit", "activeSpecial", "showPrice", "loading", "unitParams", "sizes"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const fragment = exports.fragment = (0, _client.gql)`
    fragment SearchHitRentalUnit on RentalUnit {
        id
        name
        slug
        type
        code
        brand
        amountBedrooms
        maxOccupancy
        flexCancellationDays
        hasBadge: hasFilterProperty(handle: $badgeHandle)
        hasbadge2: hasFilterProperty(handle: $badge2Handle)
        reviewStats {
            count
            average
        }
        mainImage {
            transform(config: HERO, format: WEBP) {
                src
            }
        }
        webpListImage: listImage {
            transform(config: TILE, format: WEBP) {
                ...ListImage
            }
        }
        listImage {
            transform(config: TILE, format: JPEG) {
                ...ListImage
            }
        }
        accommodation {
            id
            place
            address {
                city
            }
            name
            hasPublicPage
            collapseInSearch
            coordinates {
                lat
                lon
            }
        }
        tagline
        fullCircleImageUrl
        videoUrl
    }

    fragment SearchHitTrip on Trip {
        originalPrice
        date
        duration
        price
        type
        special {
            id
            name
            description
            landingPageUrl
        }
    }
    fragment SearchHit on UnitSearchHit {
        rentalUnit {
            ...SearchHitRentalUnit
        }
        trips {
            ...SearchHitTrip
        }
    }

    fragment ListImage on ImageTransform {
        placeholder
        srcSet
        src
        ratio
    }

    fragment Extras on AttributeCategory {
        name
        handle
        attributes {
            id
            name
            iconUrl
            handle
        }
    }
`;

// When we're loading, the data prop isn't required

const SearchHit = props => {
  const {
    getPageSlugByLocale
  } = (0, _useGetPageSlugByLocale.default)();
  const accommodationPageSlug = getPageSlugByLocale('ACCOMMODATION');
  const intl = (0, _reactIntl.useIntl)();
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  const didFilterByBrand = (0, _react.useMemo)(() => {
    const searched = (0, _queryString.parse)(props.unitParams?.searched ?? '');
    if (Array.isArray(searched?.orFilters)) {
      return searched.orFilters.includes('_brand');
    }
    return searched.orFilters?.startsWith('_brand');
  }, [props.unitParams?.searched]);
  if (props.loading) {
    return __jsx(SkeletonSearchHit, null);
  }
  const {
      rentalUnit,
      activeSpecial,
      showPrice = true,
      loading,
      unitParams: {
        arrivalDate,
        departureDate
      },
      sizes
    } = props,
    unitParams = (0, _objectWithoutProperties2.default)(props.unitParams, _excluded),
    rest = (0, _objectWithoutProperties2.default)(props, _excluded2);
  const {
    id,
    mainImage,
    slug,
    reviewStats,
    maxOccupancy,
    amountBedrooms,
    type,
    name,
    flexCancellationDays,
    tagline,
    brand,
    listImage: {
      transform: photo
    },
    webpListImage: {
      transform: webpPhoto
    },
    accommodation: {
      hasPublicPage,
      name: accommodationName,
      place,
      address: {
        city
      },
      collapseInSearch
    },
    videoUrl,
    fullCircleImageUrl
  } = rentalUnit;
  // data.trips is readonly
  const trips = [...props.trips].sort((a, b) => a.price - b.price);
  const unitType = unitParams.accommodationType === 'all' ? type : undefined;
  const subTitleText = (0, _getRentalUnitSummaryText.default)(intl, brandConfig)(city ?? place, unitType, maxOccupancy, amountBedrooms, !didFilterByBrand ? brand : undefined);

  // index lookup type should include undefined 🤨
  const bestTrip = trips[0];
  const foundTrip = activeSpecial ? trips.find(trip => trip.special?.id === activeSpecial) ?? bestTrip : bestTrip;
  const dimHit = !foundTrip && arrivalDate && departureDate;
  let leftIcon;
  if (rentalUnit.hasBadge || rentalUnit.hasbadge2) {
    leftIcon = [];
    if (rentalUnit.hasBadge && brandConfig.badge?.icon) {
      leftIcon.push(brandConfig.badge.icon);
    }
    if (rentalUnit.hasbadge2 && brandConfig.badge2?.icon) {
      leftIcon.push(brandConfig.badge2.icon);
    }
    if (leftIcon.length === 0) {
      leftIcon = undefined;
    }
  }
  const query = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, unitParams), foundTrip && (0, _trip.getDateStringsFromTrip)(foundTrip)), activeSpecial && {
    specialId: activeSpecial
  }), {}, {
    withHero: +!!mainImage?.transform?.src
  });
  return __jsx(_link.default, {
    href: {
      query,
      pathname: `/${accommodationPageSlug}/${slug}`
    },
    passHref: true,
    legacyBehavior: true
  }, __jsx(_LinkWrapper.default, {
    "data-cy": name,
    onClick: e => {
      if (props.onHitClick) {
        e.preventDefault();
        props.onHitClick(rentalUnit, (0, _queryString.stringify)(query));
      }
    }
  }, __jsx(StyledUnitTile, (0, _extends2.default)({
    photo: {
      sources: [{
        srcSet: webpPhoto?.srcSet,
        type: 'image/webp',
        sizes
      }, {
        srcSet: photo?.srcSet,
        type: 'image/jpeg',
        sizes
      }],
      fallback: {
        src: photo?.src
      },
      loading: 'lazy',
      placeholder: (0, _createPlaceholder.default)(webpPhoto?.placeholder)
    }
  }, rest, {
    style: _objectSpread(_objectSpread({}, rest.style), {}, {
      opacity: dimHit ? 0.5 : 1
    }),
    discountName: foundTrip?.type === _graphql.TripTypeEnum.LastMinute ? __jsx(_reactIntl.FormattedMessage, {
      id: "iNuliN",
      defaultMessage: [{
        "type": 0,
        "value": "Lastminute aanbieding"
      }]
    }) : foundTrip?.special?.name,
    discountDescription: foundTrip?.special?.description,
    discountIcon: foundTrip?.originalPrice ? __jsx(_Special.default, null) : __jsx(_Package.default, null),
    leftIcon: leftIcon,
    rightIcon: brandConfig.enableFavorites && __jsx(_FavoriteIconButton.default, {
      type: "rentalUnit",
      id: id,
      landingUrl: typeof window !== 'undefined' ? `${window.location.origin}/${intl.locale}/my` : undefined
    }),
    videoUrl: videoUrl,
    fullCircleImageUrl: fullCircleImageUrl
  }), __jsx(HitMeta, null, __jsx("div", null, brandConfig.hasReviews && (reviewStats?.count ? __jsx(_grid.Flex, {
    my: 2
  }, reviewStats?.average && __jsx(_Rating.default, {
    value: reviewStats.average
  })) : __jsx(_grid.Flex, {
    my: 2
  }, __jsx(Container, null, __jsx(_EmptyStar.default, null), __jsx(NoReviews, {
    variant: "small"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "XthzWc",
    defaultMessage: [{
      "type": 0,
      "value": "Geen beoordelingen"
    }]
  }))))), __jsx(HitMetaTitle, {
    variant: "small"
  }, collapseInSearch ? (0, _createUnitTitle.default)(name, accommodationName, hasPublicPage) : tagline)), __jsx("div", null, __jsx(StyledTitle, null, collapseInSearch ? tagline : (0, _createUnitTitle.default)(name, accommodationName, hasPublicPage)), __jsx(StyledText, {
    variant: "small",
    style: {
      marginTop: '0.2rem',
      fontWeight: 400
    }
  }, subTitleText), showPrice && foundTrip && __jsx(StyledPrice, null, __jsx(_UnitTile.Price, {
    originalPrice: foundTrip.originalPrice && __jsx(_reactIntl.FormattedNumber, {
      format: "EUR",
      value: foundTrip.originalPrice ?? 0
    }),
    totalPrice: __jsx(_reactIntl.FormattedNumber, {
      format: "EUR",
      value: foundTrip.price
    }),
    totalNights: __jsx(_react.default.Fragment, null, __jsx(CircleBullet, null, "\u2022"), __jsx(_reactIntl.FormattedMessage, {
      id: "bdCpFx",
      defaultMessage: [{
        "type": 2,
        "style": null,
        "value": "duration"
      }, {
        "type": 0,
        "value": " "
      }, {
        "type": 6,
        "pluralType": "cardinal",
        "value": "duration",
        "offset": 0,
        "options": {
          "one": {
            "value": [{
              "type": 0,
              "value": "nacht"
            }]
          },
          "other": {
            "value": [{
              "type": 0,
              "value": "nachten"
            }]
          }
        }
      }],
      values: {
        duration: foundTrip.duration
      }
    })),
    discountPercentage: (0, _getPercentage.default)(foundTrip.price, foundTrip.originalPrice ?? 0)
  })), flexCancellationDays ? __jsx(CancellationDay, null, __jsx(_reactIntl.FormattedMessage, {
    id: "Y0AnYW",
    defaultMessage: [{
      "type": 0,
      "value": "Gratis annuleren tot "
    }, {
      "type": 1,
      "value": "flexCancellationDays"
    }, {
      "type": 0,
      "value": " dagen"
    }],
    values: {
      flexCancellationDays
    }
  })) : __jsx(CancellationDay, null, "\xA0"), dimHit && __jsx(_UnitTile.Text, {
    variant: "large",
    style: {
      fontWeight: 500
    }
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "hL1OMg",
    defaultMessage: [{
      "type": 0,
      "value": "Niet beschikbaar"
    }]
  })))))));
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(SearchHit);
const HitMeta = exports.HitMeta = _styledComponents.default.div.withConfig({
  displayName: "SearchHit__HitMeta",
  componentId: "sc-8rxe8x-0"
})(["display:flex;flex-direction:column;align-items:start !important;height:100%;flex:1;flex-flow:column;justify-content:space-between;"]);
const StyledUnitTile = (0, _styledComponents.default)(_UnitTile.default).withConfig({
  displayName: "SearchHit__StyledUnitTile",
  componentId: "sc-8rxe8x-1"
})(["width:unset;opacity:1;height:calc(100% - 5rem);flex:1;display:flex;flex-flow:column;&&{:last-of-type{margin-right:0;}margin-right:0;}"]);
const SkeletonSearchHit = () => __jsx(_grid.Box, {
  className: "tile-m"
}, __jsx(_grid.Box, {
  style: {
    width: '100%',
    paddingBottom: 'calc(3 / 4 * 100%)',
    position: 'relative'
  }
}, __jsx(_grid.Box, {
  style: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  }
}, __jsx(_reactLoadingSkeleton.default, {
  width: "100%",
  height: "100%"
}))), __jsx(_Stack.default, {
  spacing: 3,
  marginTop: 4,
  style: {
    overflow: 'hidden'
  }
}, new Array(3).fill(null).map((_, i) => __jsx(SkeletonField, {
  key: i
}))));
const SkeletonField = () => {
  const random = (0, _useRandom.useRandom)(60, 350);
  return __jsx(_reactLoadingSkeleton.default, {
    height: "30",
    width: random
  });
};
const StyledTitle = _styledComponents.default.p.withConfig({
  displayName: "SearchHit__StyledTitle",
  componentId: "sc-8rxe8x-2"
})(["color:", ";font-size:1.6rem;margin-bottom:", ";margin-top:0.8rem;font-weight:400;"], ({
  theme
}) => theme.colors.neutral['60'], ({
  theme
}) => theme.spacing['10_Micro']);
const StyledPrice = _styledComponents.default.div.withConfig({
  displayName: "SearchHit__StyledPrice",
  componentId: "sc-8rxe8x-3"
})(["> p{line-height:1.5;font-weight:700;}* > span{font-weight:400;color:", ";}"], ({
  theme
}) => theme.colors.neutral['60']);
const CircleBullet = _styledComponents.default.span.withConfig({
  displayName: "SearchHit__CircleBullet",
  componentId: "sc-8rxe8x-4"
})(["margin-right:0.8rem;"]);
const NoReviews = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "SearchHit__NoReviews",
  componentId: "sc-8rxe8x-5"
})(["font-weight:700;color:#6f6f6f;margin-left:0.4rem;"]);
const HitMetaTitle = (0, _styledComponents.default)(_Title.default).withConfig({
  displayName: "SearchHit__HitMetaTitle",
  componentId: "sc-8rxe8x-6"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"]);
const Container = _styledComponents.default.div.withConfig({
  displayName: "SearchHit__Container",
  componentId: "sc-8rxe8x-7"
})(["display:flex;align-items:center;color:", ";> p{margin-left:", ";font-weight:700;}> svg{margin-top:-", ";width:1.6rem;}"], ({
  theme
}) => theme.colorAssignments.rating ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.rating) : theme.colors.secondary['30'], ({
  theme
}) => theme.spacing['20_Tiny'], ({
  theme
}) => theme.spacing['10_Micro']);
const CancellationDay = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "SearchHit__CancellationDay",
  componentId: "sc-8rxe8x-8"
})(["color:", ";font-size:1.5rem;font-weight:700;@media screen and (min-width:1440px){font-size:1.5rem;}@media screen and (max-width:1440px){font-size:1.4rem;}@media screen and (max-width:1035px){font-size:1.3rem;}@media screen and (max-width:1020px){font-size:1.4rem;}@media screen and (max-width:720px){font-size:1.3rem;}@media screen and (max-width:650px){font-size:1.4rem;}@media screen and (max-width:353px){font-size:1.2rem;}"], ({
  theme
}) => theme.colors.secondary['30']);
const StyledText = (0, _styledComponents.default)(_UnitTile.Text).withConfig({
  displayName: "SearchHit__StyledText",
  componentId: "sc-8rxe8x-9"
})(["color:", ";font-size:1.6rem;"], ({
  theme
}) => theme.colors.neutral['60']);